/* 产引入jsencrypt实现数据RSA加密 */
import JSEncrypt from 'jsencrypt' // 处理长文本数据时报错 jsencrypt.js Message too long for RSA
/* 产引入encryptlong实现数据RSA加密 */
import Encrypt from 'encryptlong' // encryptlong是基于jsencrypt扩展的长文本分段加解密功能。（文本太长就换这个

// 公钥key
const publicKey = ``
// 私钥key
const privateKey = ``
/* JSEncrypt加密 */
function rsaPublicData(key,data) {
	var jsencrypt = new JSEncrypt()
	jsencrypt.setPublicKey(key)
	// 如果是对象/数组的话，需要先JSON.stringify转换成字符串
	var result = jsencrypt.encrypt(data)
	return result
}
/* JSEncrypt解密 */
function rsaPrivateData(key,data) {
	var jsencrypt = new JSEncrypt()
	jsencrypt.setPrivateKey(key)
	// 如果是对象/数组的话，需要先JSON.stringify转换成字符串
	var result = jsencrypt.decrypt(data)
	return result
}
/* 加密 */
function encrypt(data) {
	const PUBLIC_KEY = publicKey
	var encryptor = new Encrypt({default_key_size:2048})
	encryptor.setPublicKey(PUBLIC_KEY)
	// 如果是对象/数组的话，需要先JSON.stringify转换成字符串
	const result = encryptor.encryptLong(data)
	return result
}
/* 解密 - PRIVATE_KEY - 验证 */
function decrypt(data) {
	const PRIVATE_KEY = privateKey
	var encryptor = new Encrypt({default_key_size:2048})
	encryptor.setPrivateKey(PRIVATE_KEY)
	// 如果是对象/数组的话，需要先JSON.stringify转换成字符串
	var result = encryptor.decryptLong(data)
	return result
}


export default {
	// 加密
	setRsa(key,data) {
		var msg = `-----BEGIN PUBLIC KEY-----
		${key}
		-----END PUBLIC KEY-----`
		return rsaPublicData(msg,data)
		return encrypt(data)
	},
	// 解密
	getRsa(data) {
		var key = `
		-----BEGIN RSA PRIVATE KEY-----
		MIIEowIBAAKCAQEAvgv3UJGmbLkmbxh0LbRjj6HyJAh1p1XIPQlvZMpgqWx19CrIQGwjBMDo/Z34usldGsonNFz/SarNcPJKW0LA46kn9A1HuDT9lPah/kTMcsUIvL3a63m/+5mszvPoNiWvY5a4yiFNlmGSIRoSD5oCDua/63GQf2caxr2QhgjuC95Hegydiq701zlewxLvVQrcAvjIc4glRtNUPa1pRubDJH5ksNUTJx+YeWPAah1/CSi8Scox9VCHJhtkWm4jCzTPTTzfMZ4VvaO9bbed4lbLYfenOpNPjowUG2zB4bhpqx7AtU2esEqGldH3t6MfUESP0YkIJwP/Uf+EaGwVriFeNQIDAQABAoIBAFUr0bO3Asn5FGN3pyGQlYoafwVtESVkSXApWVXnaPilFhvOTJ6ql+sadZCsCnvToLlP3dAW2YZvWNEElRRfT0j4V2KFzR2eCgOHoMPum13YNfk4cPNVRhgBIDRDlU8nBnpwYvKbiEUcBzx0jaGWWNPK0Do5VBP05kgpTqrzN5PzTXG0+mkLeKo7XsPY2qIiHMKZ4Qel6UteXmLc3UkiGSNi4qI160a+wUpnuXt77Uq0aYCXd3EamJHyTAYw3hFDbe7H3456/C07iNgxSomJo6Pv6QthOkYKc9+EwML83Rj1aTfmAChBI4RkF2MiCNYBQlzVUug1kbdpnSKPeUCgYEA45o16dRhFSDQoTdpargoAU1hbOp/Wks1n7imz/cbFZtGfejvRPqzTkWgGX+igz8vMdwhALUF2urOnozEgH46DU5dQEzcJrjGybo35t+LuF3khmEpXkQF0Hq8Bt+2LjdP70//0evaNI29ilWKEmfehpUZTCOU9o1KQ5ywRZLp7YsCgYEA1cIzSHovxEPlGelIgb7PbkX0xJgLckrM+Xl8EYqIr6GkEnTVfyuXdXFxNtfkYvcSvflvpEdcPJzCud+rJ/x3owkpo0MgwQMx2Fp035lYz3nIWwpTaOKVdJ2NSq/MtgsBjMVjMFemui/Q9FnXunPkQaFVGn3bSA5iRt+f1xhO2z8CgYAbGVJP++xvMpAEke9oOHLy7L6r1CPDoW7KDJc37aj44pr7BM/wO5U7vYh5YLv9unkpC5eWWPdQgGKHeCUxU1YgHXN242/W4Gsyu4xKXdVp5yv9X/Yn9htnHiXi/6HWUNmgmbrQyK8bUMD/hn3BAUL6bSgs65Oh42KzOCW4suxNTwKBgD9865BmQhOv+rbEc/WdP6zH+Ff/tL6getrJ+1CWbdyETN/ydYrM3rJSHEcmvj2qlpV4JXGMhFe4U5mzVfmNYdc5nHVSNcM9+KsCyt2yhQ8yY5Cus3Fegvdc6B87sbiL8kzmP3yXO/zmwNAicxF85Fmd2lIA+YUgSI42UxomrR0vAoGBAJs1Apld1OXy/SCN9hMyW0zO9GJ8oWXuBjOWgmLxNYM3r658lTaOBSlJmF0I/arP4HNW7XZAvNEfcDs5yy8p4ctas57lmZTtrDth5x1jqRV5wKZTWYMxKlswJ+u1zEg8e+O5x1iR1eX14Mziq6dyPvxz8h2lk49JixDTsVKmG1qn
		-----END RSA PRIVATE KEY-----
		`
		return rsaPrivateData(key,data)
		return decrypt(data)
	},
}
